<!-- mettal-3\src\components\View722.vue -->
<!-- <template>
  <div :class="[`view-440`, className || ``]">
    <div class="rectangle-95-21"></div>
  </div>
</template>

<script>
export default {
  name: "View722",
  props: ["className"],
};
</script>

<style>
.view-440 {
  background-color: #0095ec26;
  display: flex;
  margin-left: -1087px;
  margin-top: 21px;
  transform: rotate(90deg);
  width: 2182px;
}

.rectangle-95-21 {
  background-color: #0095ec66;
  border-radius: 5px;
  height: 8px;
  margin-left: 34px;
  width: 100px;
}

.view-440.view-441 {
  background-color: var(--quick-silver);
  height: 8px;
  left: 825px;
  margin-left: unset;
  margin-top: unset;
  position: absolute;
  top: 1147px;
}

.view-440.view-441 .rectangle-95-21 {
  background-color: var(--black-3);
}
</style> -->

<template>
  <div class="view-722">
    <!-- Your component content here -->
  </div>
</template>

<script>
export default {
  name: 'View722'
}
</script>

<style scoped>
/* Your styles here */
</style>